import React from 'react'
import { Route } from 'react-router-dom'
import { auth } from '../../../services/util/auth.service'
import DashboardMenu from './DashboardMenu/DashboardMenu'
import StatusOperacoesLogisticas from './StatusOperacoesLogisticas/StatusOperacoesLogisticas'
import EtapaPicking from './StatusOperacoesLogisticas/EtapaPicking'
import EtapaResumoSeparacao from './StatusOperacoesLogisticas/EtapaResumoSeparacao'
import EtapaCarregamento from './StatusOperacoesLogisticas/EtapaCarregamento'
import EtapaEnvioRota from './StatusOperacoesLogisticas/EtapaEnvioRota'
import EtapaApuracaoEntregas from './StatusOperacoesLogisticas/EtapaApuracaoEntregas'
import EtapaOrdemColeta from './StatusOperacoesLogisticas/EtapaOrdemColeta'
import ExpedicaoTPs from './ExpedicaoTPs/ExpedicaoTPs'
import CargasParadasTPs from './CargasParadasTPs/CargasParadasTPs'
import DevolucoesPendentesTPs from './DevolucoesPendentesTPs/DevolucoesPendentesTPs'
import ResultadoPorEmpresa from './ResultadoPorEmpresa/ResultadoPorEmpresa'
import ProdutividadeSeparacao from './ProdutividadeSeparacao/ProdutividadeSeparacao'
import ProdutividadeExpedicao from './ProdutividadeExpedicao/ProdutividadeExpedicao'
import PainelVeiculosEmRota from './PainelVeiculosEmRota/PainelVeiculosEmRota'
import AcompanhamentoPicking from './AcompanhamentoPicking/AcompanhamentoPicking'
import PainelMonitoramentoEntregas from './PainelMonitoramentoEntregas/PainelMonitoramentoEntregas'

export default function Dashboard() {
  return (
    <>
      <Route path="/main/dashboard/menu" render={() => auth(<DashboardMenu />)} />
      <Route
        path="/main/dashboard/status-operacoes-logisticas"
        render={() => auth(<StatusOperacoesLogisticas />, 53)}
      />
      <Route
        path="/main/dashboard/status-operacoes-etapa-picking"
        render={() => auth(<EtapaPicking />, 53)}
      />
      <Route
        path="/main/dashboard/status-operacoes-etapa-resumo-separacao"
        render={() => auth(<EtapaResumoSeparacao />, 53)}
      />
      <Route
        path="/main/dashboard/status-operacoes-etapa-carregamento"
        render={() => auth(<EtapaCarregamento />, 53)}
      />
      <Route
        path="/main/dashboard/status-operacoes-etapa-envio-rota"
        render={() => auth(<EtapaEnvioRota />, 53)}
      />
      <Route
        path="/main/dashboard/status-operacoes-etapa-apuracao-entregas"
        render={() => auth(<EtapaApuracaoEntregas />, 53)}
      />
      <Route
        path="/main/dashboard/status-operacoes-etapa-ordem-coleta"
        render={() => auth(<EtapaOrdemColeta />, 53)}
      />
      <Route path="/main/dashboard/expedicao-tps" render={() => auth(<ExpedicaoTPs />, 54)} />
      <Route
        path="/main/dashboard/cargas-paradas-tps"
        render={() => auth(<CargasParadasTPs />, 55)}
      />
      <Route
        path="/main/dashboard/devolucoes-pendentes-tps"
        render={() => auth(<DevolucoesPendentesTPs />, 56)}
      />
      <Route
        path="/main/dashboard/resultado-por-empresa"
        render={() => auth(<ResultadoPorEmpresa />, 57)}
      />
      <Route
        path="/main/dashboard/produtividade-separacao"
        render={() => auth(<ProdutividadeSeparacao />, 58)}
      />
      <Route
        path="/main/dashboard/painel-veiculos-em-rota"
        render={() => auth(<PainelVeiculosEmRota />, 59)}
      />
      <Route
        path="/main/dashboard/acompanhamento-picking"
        render={() => auth(<AcompanhamentoPicking />, 60)}
      />
      <Route
        path="/main/dashboard/painel-monitoramento-entregas"
        render={() => auth(<PainelMonitoramentoEntregas />, 139)}
      />
      <Route
        path="/main/dashboard/produtividade-expedicao"
        render={() => auth(<ProdutividadeExpedicao />, 150)}
      />
    </>
  )
}
